import { message, Popconfirm, Tooltip } from 'antd'
import { Icon } from '@iconify/react'

import AddCandidatesDropdown from '../../modules/jobApplications/components/AddCandidateDropdown'
import { PUBLIC_ROUTES } from '../../routes'
import styles from './BackAndEdit.module.css'

const BackAndEdit = ({
    isBack = true,
    onBack = null,
    isEdit = true,
    onEdit = null,
    onArchive = null,
    canEdit = true,
    canDelete = true,
    state,
    params,
}) => {
    return (
        <div className={styles.actions}>
            <Tooltip title="Copy Job Link">
                <button
                    type="button"
                    className={styles.iconBtn}
                    onClick={() => {
                        const relativeUrl = PUBLIC_ROUTES.jobCandidateDetail(
                            params.id
                        )
                        const url = `${window.location.origin}${relativeUrl}`

                        navigator.clipboard
                            .writeText(url)
                            .then(() => {
                                message.success('Job link copied to clipboard!')
                            })
                            .catch(() => {
                                message.error('Failed to copy link')
                            })
                    }}
                    aria-label="Copy Job Link"
                >
                    <Icon icon="mdi:link-variant" width={18} height={18} />
                </button>
            </Tooltip>
            <Tooltip title="View Job">
                <button
                    type="button"
                    className={styles.iconBtn}
                    onClick={() => {
                        const url = PUBLIC_ROUTES.jobCandidateDetail(params.id)
                        window.open(url, '_blank')
                    }}
                    aria-label="View Job"
                >
                    <Icon icon="mdi:eye-outline" width={18} height={18} />
                </button>
            </Tooltip>
            {isEdit && canEdit ? (
                <Tooltip title="Edit Job">
                    <button
                        type="button"
                        className={styles.iconBtn}
                        onClick={onEdit}
                        aria-label="Edit Job"
                    >
                        <Icon icon="mdi:pencil-outline" width={17} height={17} />
                    </button>
                </Tooltip>
            ) : null}

            {canDelete ? (
                <Popconfirm
                    title="Archive Job"
                    description="Are you sure to archive this Job?"
                    onConfirm={onArchive}
                    icon={null}
                    okText="Yes"
                    cancelText="Cancel"
                    okButtonProps={{
                        style: {
                            padding: '0px 10px',
                            backgroundColor: '#4F46E5',
                        },
                    }}
                    cancelButtonProps={{
                        style: {
                            backgroundColor: 'transparent',
                            border: 'none',
                            padding: '0px 10px',
                            color: 'black',
                            boxShadow: 'none',
                        },
                    }}
                >
                    <Tooltip title="Archive Job">
                        <button
                            type="button"
                            className={`${styles.iconBtn} ${styles.iconBtnDanger}`}
                            aria-label="Archive Job"
                        >
                            <Icon
                                icon="mdi:archive-arrow-down-outline"
                                width={17}
                                height={17}
                            />
                        </button>
                    </Tooltip>
                </Popconfirm>
            ) : null}
            {isBack && (
                <Tooltip title="Back">
                    <button
                        type="button"
                        className={`${styles.iconBtn} ${styles.iconBtnNeutral}`}
                        onClick={onBack}
                        aria-label="Back"
                    >
                        <Icon icon="mdi:arrow-left" width={18} height={18} />
                    </button>
                </Tooltip>
            )}
            {canEdit ? <AddCandidatesDropdown state={state} /> : null}
        </div>
    )
}

export default BackAndEdit
